import React from 'react';
import { Modal, Alert, Button } from 'react-bootstrap';

class CreateUserLog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      log: [],
      socket: null,
      status: null, // null | 'in-progress' | 'success' | 'danger'
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  logMessage(message) {
    this.setState((prevState) => ({
      log: [...prevState.log, message],
    }));
  }

  handleSubmit() {
    const { input, selectedUser, uploading = false, mode = 'create' } = this.props;

    let payload;

    if (mode === 'delete') {
      if (!selectedUser) {
        this.setState({ status: 'danger' });
        this.logMessage('[Error] No user selected to delete.');
        return;
      }
      payload = {
        action: 'DeleteUser_WebSocket',
        input: selectedUser
      };
    } else {
      if (!input || typeof input !== 'object') {
        this.setState({ status: 'danger' });
        this.logMessage('[Error] Invalid or missing input prop.');
        return;
      }
      payload = {
        action: mode === 'update' ? 'UpdateUser_WebSocket' : 'CreateUser_WebSocket',
        input,
        uploading
      };
    }

    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const socketUrl = `ws://10.200.50.25:4000/ws`;

    const socket = new WebSocket(socketUrl);
    this.setState({ socket, log: [], status: 'in-progress' });

    socket.onopen = () => {
      this.logMessage('[WebSocket] Connected');
      socket.send(JSON.stringify(payload));
    };

    socket.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);

        if (msg.type === 'progress') {
          if (this.state.status !== 'in-progress') {
            this.setState({ status: 'in-progress' });
          }
          this.logMessage(`[Progress] ${msg.stage}: ${msg.message}`);
        } else if (msg.type === 'result') {
          this.setState({ status: 'success' });
          this.logMessage(`[Result] User ${mode} successful.`);
          this.logMessage(JSON.stringify(msg.result, null, 2));
          socket.close();
        } else if (msg.type === 'error') {
          this.setState({ status: 'danger' });
          this.logMessage(`[Error] ${msg.message}`);
          socket.close();
        }
      } catch (err) {
        this.setState({ status: 'danger' });
        this.logMessage(`[Error] Failed to parse message: ${event.data}`);
        socket.close();
      }
    };

    socket.onerror = (err) => {
      this.setState({ status: 'danger' });
      this.logMessage(`[WebSocket] Error: ${err.message}`);
    };

    socket.onclose = () => {
      this.logMessage('[WebSocket] Connection closed');
    };
  }

  handleClose() {
    if (this.state.socket) {
      this.state.socket.close();
    }

    this.setState({ log: [], status: null, socket: null });
    if (this.state.status) {
		this.props.onClose()
	}else
		this.props.onCancel()
	
  }

  render() {
    const { show, mode = 'create' } = this.props;
    const { log, status } = this.state;

    const titles = {
      create: 'Create User',
      update: 'Update User',
      delete: 'Delete User'
    };

    const actionLabels = {
      create: 'Create User',
      update: 'Update User',
      delete: 'Delete User'
    };

    const successMessages = {
      create: 'User created successfully!',
      update: 'User updated successfully!',
      delete: 'User deleted successfully!'
    };

    const errorMessages = {
      create: 'An error occurred during user creation.',
      update: 'An error occurred during user update.',
      delete: 'An error occurred during user deletion.'
    };

    return (
      <Modal show={show} onHide={this.handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{titles[mode]}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {status === 'success' && <Alert variant="success">{successMessages[mode]}</Alert>}
          {status === 'danger' && <Alert variant="danger">{errorMessages[mode]}</Alert>}
          <pre style={{ backgroundColor: '#f9f9f9', padding: '10px', height: '300px', overflowY: 'scroll' }}>
            {log.join('\n')}
          </pre>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose}>
            Close
          </Button>
          <Button
            variant={mode === 'delete' ? 'danger' : 'primary'}
            disabled={status}
            onClick={this.handleSubmit}
          >
            Start: {actionLabels[mode]}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default CreateUserLog;
